<template>
  <div>
    <div>
      <div class="font-weight-bold mb-1 mt-5">
        Contact Details
      </div>
      <div v-for="(step, index) in allSteps" :key="index">
        <component
          :submitButtonTitle="submitButtonTitle"
          :is="step"
          v-if="
            shouldStepViewBeShown(index) || ifStepHasAlreadyBeenCompleted(index)
          "
          v-show="shouldStepViewBeShown(index)"
          @nextStep="stepForward"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Address from "@/views/profile/QuestionsAndAnswers/steps/ContactDetails/Address";
import PhoneNumber from "@/views/profile/QuestionsAndAnswers/steps/ContactDetails/PhoneNumber";
import { isPermissioned } from "@/utils/permissions";
import { size } from "lodash";
import { PERMISSIONS } from "@/constants/workers";
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { EDIT_USER } from "@/store/modules/users/actions";
import { USERS_NAMESPACE } from "@/store/modules/users";

const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);
const { mapActions: mapUserActions } = createNamespacedHelpers(USERS_NAMESPACE);

const { CONTACT_DETAILS } = PERMISSIONS;

export default {
  components: {
    Address,
    PhoneNumber
  },
  props: {
    submitButtonTitle: String
  },
  created() {
    this.emitProgressValue({ step: this.steps.current });
  },
  data() {
    return {
      userData: {},
      steps: {
        current: 1,
        saved: 0
      },
      showValidationErrors: false,
      allSteps: [
        this.showStep(CONTACT_DETAILS.address) && Address,
        this.showStep(CONTACT_DETAILS.phoneNumber) && PhoneNumber
      ].filter(Boolean)
    };
  },
  computed: {
    ...mapAuthState({
      self: state => state.userData
    }),
    progressValue() {
      return (this.steps.current / this.totalSteps) * 100;
    },
    totalSteps() {
      return size(this.allSteps);
    },
    // needed value for parent form component
    showBackButton() {
      return this.steps.current > 1;
    }
  },
  methods: {
    ...mapUserActions({
      editUser: EDIT_USER
    }),
    emitProgressValue({ step }) {
      this.$emit("onStepChanged", {
        progressValue: (step / this.totalSteps) * 100
      });
    },
    onClose() {
      this.$emit("close");
    },
    stepForward({ data }) {
      this.userData = { ...this.userData, ...data };
      if (this.steps.current === this.totalSteps) {
        this.onEdit();
      } else {
        if (this.steps.current > this.steps.saved) {
          this.steps.saved += 1;
        }
        this.emitProgressValue({ step: this.steps.current + 1 });
        this.steps.current += 1;
      }
    },
    async onEdit() {
      await this.editUser({
        id: this.self.id,
        data: this.userData
      });
      this.emitProgressValue({ step: this.steps.current + 1 });
      this.onClose();
    },
    stepBack() {
      this.emitProgressValue({ step: this.steps.current - 1 });
      if (this.steps.current > 1) {
        this.steps.current--;
      }
    },
    shouldStepViewBeShown(index) {
      const viewStep = index + 1;
      return viewStep <= this.totalSteps && this.steps.current === viewStep;
    },
    ifStepHasAlreadyBeenCompleted(index) {
      const viewStep = index + 1;
      return viewStep <= this.steps.saved;
    },
    showStep(permission) {
      return isPermissioned(`workers.edit.${permission}`);
    }
  }
};
</script>

<style lang="scss"></style>
